import { ITransfer } from '@/contracts/modules/note/entities/ITransfer'
import { EnumTransferKind } from '@/contracts/modules/note/enum/EnumTransferKind'
import { EnumTransferState } from '@/contracts/modules/note/enum/EnumTransferState'
import { EnumNoteFileError } from '@/contracts/modules/note/enum/EnumNoteFileError'

/** Передача в очереди; состояние меняет только очередь модуля */
export class Transfer implements ITransfer {
  private done = 0
  private state = EnumTransferState.QUEUED
  private error: EnumNoteFileError | null = null
  private cancelRequested = false

  constructor(private id: string, private kind: EnumTransferKind, private title: string, private size: number) {}

  getId(): string {
    return this.id
  }

  getKind(): EnumTransferKind {
    return this.kind
  }

  getTitle(): string {
    return this.title
  }

  getSize(): number {
    return this.size
  }

  getDone(): number {
    return this.done
  }

  getState(): EnumTransferState {
    return this.state
  }

  getError(): EnumNoteFileError | null {
    return this.error
  }

  isCancelRequested(): boolean {
    return this.cancelRequested
  }

  isFinished(): boolean {
    return this.state === EnumTransferState.DONE || this.state === EnumTransferState.FAILED || this.state === EnumTransferState.CANCELLED
  }

  _setDone(done: number): void {
    this.done = Math.min(done, this.size)
  }

  _setState(state: EnumTransferState, error: EnumNoteFileError | null = null): void {
    this.state = state
    this.error = error
  }

  _requestCancel(): void {
    this.cancelRequested = true
  }
}
